export default "__VITE_ASSET__CQodGDh5__"